import gql from 'graphql-tag';

export const VIEWER_ORG_TEAM_ACCESS = gql`
  query ViewerOrgTeamAccess(
    $orgName: String!
    $viewerId: ID!
    $username: String
  ) {
    organization(name: $orgName) {
      id
      member(username: $username) {
        id
        role
      }
      teams {
        id
        name
        member(id: $viewerId) {
          id
          role
        }
      }
    }
  }
`;
